export const brandIdentity = {
  title: 'Brand Identity',
  subtitle: 'Configure your visual identity for AI-generated images',

  form: {
    colors: {
      title: 'Brand Colors',
      subtitle: 'Define your brand color palette',
    },
    primaryColor: {
      label: 'Primary Color',
      placeholder: '#3B82F6',
    },
    secondaryColor: {
      label: 'Secondary Color',
      placeholder: '#6366F1',
    },
    accentColor: {
      label: 'Accent Color',
      placeholder: '#F59E0B',
    },
    additionalColors: {
      label: 'Additional Colors',
      add: 'Add color',
      placeholder: '#RRGGBB',
    },
    typography: {
      title: 'Typography',
      subtitle: 'Fonts used in your brand',
    },
    primaryFont: {
      label: 'Primary Font',
      placeholder: 'e.g., Inter, Helvetica',
    },
    secondaryFont: {
      label: 'Secondary Font',
      placeholder: 'e.g., Georgia, Merriweather',
    },
    logo: {
      title: 'Brand Logo',
      subtitle: 'Upload your logo for image watermark overlay',
      upload: 'Upload logo',
      change: 'Change logo',
      formats: 'PNG, SVG, or WebP recommended',
    },
    guidelines: {
      title: 'Brand Guidelines',
      subtitle: 'Free-form instructions for AI image generation',
      placeholder:
        'e.g., Use minimalist style, avoid cluttered backgrounds, prefer clean modern aesthetics...',
    },
    colorInvalid: 'Must be a valid hex color (e.g. #FF5500)',
    save: 'Save',
    saving: 'Saving...',
  },

  preview: {
    title: 'Preview',
    colorPalette: 'Color Palette',
    fonts: 'Typography',
    primary: 'Primary',
    secondary: 'Secondary',
    accent: 'Accent',
  },

  playground: {
    title: 'Image Playground',
    subtitle: 'Test how your brand identity looks in AI-generated images',
    titleLabel: 'Image title',
    titlePlaceholder: 'e.g., How to improve digital security',
    styleLabel: 'Visual style',
    promptLabel: 'Custom prompt (optional)',
    promptPlaceholder: 'e.g., Minimalist, clean background, tech-focused',
    generate: 'Generate Image',
    generating: 'Generating...',
    referenceImages: {
      label: 'Reference images',
      subtitle: 'Upload 1-3 images to replicate their visual style',
      dropzone: 'Click or drag images here',
      maxReached: 'Maximum 3 images',
      tooLarge: 'Image must be under 5MB',
      invalidType: 'Only image files are allowed',
    },
    galleryPicker: {
      label: 'Saved reference images',
      subtitle: 'Select up to 3 images from your gallery',
      empty: 'No saved images yet',
    },
  },

  referenceGallery: {
    title: 'Reference Images',
    subtitle: 'Upload template images to replicate their visual style in generated content',
    upload: 'Upload image',
    empty: 'No reference images yet',
    emptySubtitle: 'Upload images to use as visual style templates',
    deleteConfirm: 'Delete this reference image?',
    maxReached: 'Maximum 10 images reached',
    tooLarge: 'Image must be under 5MB',
    invalidType: 'Only image files are allowed',
  },

  toast: {
    saveSuccess: 'Brand identity saved successfully',
    saveError: 'Error saving brand identity: {{message}}',
    logoSuccess: 'Logo uploaded successfully',
    logoError: 'Error uploading logo: {{message}}',
    playgroundError: 'Image generation failed: {{message}}',
    referenceImageUploadSuccess: 'Reference image uploaded',
    referenceImageUploadError: 'Error uploading reference image: {{message}}',
    referenceImageDeleteSuccess: 'Reference image deleted',
    referenceImageDeleteError: 'Error deleting reference image: {{message}}',
  },
} as const
